<template>
  <div class="q-pb-xl">
    <div class="q-pb-xl">
      <div class="fill-height q-px-xl q-pt-xl">
        <div class="row q-mt-lg items-center justify-between q-mb-lg">
          <div class="col-shrink text-left">
            <span class="text-h5">{{ i18n.title }} ({{ invitations.length }})</span>
          </div>
        </div>

        <q-card
          v-if="invitations.length === 0"
          class="q-pa-lg text-center"
        >
          <div class="text-muted">
            {{ i18n.noRequests }}
          </div>
        </q-card>

        <div
          v-else
          class="row q-col-gutter-md"
        >
          <div
            v-for="invitation in invitations"
            :key="invitation.id"
            class="col-12 col-md-6 col-lg-4"
          >
            <q-card class="q-pa-md">
              <div class="text-h6 q-mb-sm">
                {{ invitation.workspace_name }}
              </div>
              <div class="text-caption text-grey q-mb-md">
                {{ i18n.requestedOn.replace('%{0}', invitation.created_at) }}
              </div>
              <div class="text-right">
                <q-btn
                  color="positive"
                  :label="i18n.acceptButton"
                  unelevated
                  no-caps
                  @click="acceptInvitation(invitation)"
                />
              </div>
            </q-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/layouts/wg_admin.vue';

export default {
  layout: Layout,
  props: {
    invitations: {
      type: Array,
      required: true,
    },
    i18n: {
      type: Object,
      required: true,
    },
  },
  methods: {
    acceptInvitation(invitation) {
      this.$q.dialog({
        title: this.i18n.acceptConfirmTitle,
        message: this.i18n.acceptConfirmMessage.replace('%{0}', invitation.workspace_name),
        cancel: true,
        persistent: true,
        color: 'primary',
      }).onOk(() => {
        this.$inertia.post(
          `/wg_admin/${this.$page.props.shared.wg.id}/workspace_group_invitations/${invitation.id}/accept`,
          {},
          {
            onSuccess: () => {
              this.$q.notify({
                message: this.$page.props.flash.notice,
                type: 'positive',
              });
            },
            onError: () => {
              this.$q.notify({
                message: this.$page.props.flash.alert,
                type: 'negative',
              });
            },
          }
        );
      });
    },
  },
};
</script>
